import { getUrlParams } from "@/utils";
import { HASH_KEYS, IMAGE_RESOURCE_DOMAIN, MODE_TYPE } from "@/utils/domain";
import { HashOnly } from "@/utils/hash";

const NODE_ENV: MODE_TYPE = import.meta.env.VITE_APP_ENV as MODE_TYPE;
type PlatformResourceConfig = (typeof IMAGE_RESOURCE_DOMAIN)[HashOnly.merchant_default];

console.log("[MODE_TYPE]: ", NODE_ENV, JSON.stringify(import.meta.env));

// 获取ql用户平台类型
export const getPlatformType = () => {
	const ql_platform_type = getUrlParams("platform_type") as HASH_KEYS;
	return ql_platform_type;
};

// 获取资源类型uri等
export const getPlatformUrl = (ql_platform_type: HASH_KEYS) => {
	const getModeConfig = (config: PlatformResourceConfig) => {
		switch (NODE_ENV) {
			case "production":
				return config.production;
			case "staging":
				return config.staging;
			case "localnet":
				return config.localnet;
			default:
				return config.development;
		}
	};

	switch (ql_platform_type) {
		case HashOnly.merchant_default:
			return getModeConfig(IMAGE_RESOURCE_DOMAIN[HashOnly.merchant_default]);
		case HashOnly.merchant_3:
			return getModeConfig(IMAGE_RESOURCE_DOMAIN[HashOnly.merchant_3]);
		default:
			return getModeConfig(IMAGE_RESOURCE_DOMAIN[HashOnly.merchant_default]);
	}
};
